import { styled } from 'styled-components';

import { breakpointLargeTablet, breakpointTablet } from 'app/style/breakpoints';
import { colorNeutral } from 'app/style/colors';
import { spacing2 } from 'app/style/spacing';

export const StyledLinkContainer = styled.div`
    &:not(:last-child) {
        padding-bottom: ${spacing2};
    }

    @media (min-width: ${breakpointTablet}) {
        text-align: right;
    }

    @media (min-width: ${breakpointLargeTablet}) {
        &:not(:last-child) {
            padding-bottom: 0;
        }

        &:not(:last-child)::after {
            color: ${colorNeutral};
            content: '/';
            padding: 0 ${spacing2};
        }
    }
`;
